import angular from 'angular';
import './customer-order-list';
import './customer-order-details';

angular.module('folkeuni').component('customerOrders', {
    templateUrl: '/shop-dist/templates/customer-orders.html',
    transclude: false,
    bindings:{
      guid:'@',
      orderId:'@'
    },
    controller: function(Orders) {
        var $ctrl = this;
        $ctrl.orderCurrent = null;
}});
